import importerReducers from '../../../modules/shared/importer/importerReducers'
import actions from '../../../modules/service/importer/serviceImporterActions'

export default importerReducers(actions)
